export const iconFontAwesomeDevicesHardwareHouseLaptop = (
	<i className="fa-solid fa-house-laptop"></i>
);
